import React from "react";
import MovieList from "./MovieList";
import { useSelector } from "react-redux";

const MovieContainer = () => {
  const movie = useSelector((store) => store.movie);
  if (!movie) return null;
  return (
    <div className="bg-netflix pb-12 shadow-inner">
  <div className="-mt-32 sm:-mt-16 lg:-mt-52 relative z-10 px-2 sm:px-0 ">
        <MovieList title={"Now Playing Movies"} movies={movie.nowPlayingMovies} />
        <MovieList title={"Popular Movies"} movies={movie.popularMovies} />
        <MovieList title={"Top Rated Movies"} movies={movie.topRatedMovies} />
        <MovieList title={"Upcoming Movies"} movies={movie.upcomingMovies} />
      </div>
    </div>
  );
};

export default MovieContainer;
